import { render, staticRenderFns } from "./data37.vue?vue&type=template&id=0af33cc8&scoped=true"
import script from "./data37.vue?vue&type=script&lang=js"
export * from "./data37.vue?vue&type=script&lang=js"
import style1 from "./data37.vue?vue&type=style&index=1&id=0af33cc8&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0af33cc8",
  null
  
)

export default component.exports